// extracted by mini-css-extract-plugin
module.exports = {"root":"PeopleSymbol_root__3VSbG","people":"PeopleSymbol_people__1VCWa"};